// Полифиллы для основной (не legacy) сборки pdf.js 5.x, которую подключает react-pdf.
// Без них в iOS Safari < 18 / Chrome < 126 падает "URL.parse is undefined",
// а в Safari < 17.4 — "Promise.withResolvers is not a function".
// Остальные новые API pdf.js проверяет сам (toHex, fromBase64, Promise.try, Math.sumPrecise).
// Воркер pdf.js полифиллы не видит — для него используется legacy-сборка (см. scripts/copy-pdf-worker.js).

const URLCtor = URL as any;
if (typeof URLCtor.parse !== "function") {
  URLCtor.parse = function parse(url: string | URL, base?: string | URL): URL | null {
    try {
      return base === undefined ? new URL(url) : new URL(url, base);
    } catch {
      return null;
    }
  };
}

const PromiseCtor = Promise as any;
if (typeof PromiseCtor.withResolvers !== "function") {
  PromiseCtor.withResolvers = function withResolvers<T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new this((res: typeof resolve, rej: typeof reject) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

export {};
